 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_PREFACE_ from '@/components/xhtml/05_Preface_'
 import XHTML06_1__WHAT from '@/components/xhtml/06_1__What'
 import XHTML07_2__FLEEI from '@/components/xhtml/07_2__Fleei'
 import XHTML08_3__A_1_P from '@/components/xhtml/08_3__A_1_P'
 import XHTML09_4__THE_C from '@/components/xhtml/09_4__The_C'
 import XHTML10_5__A_BET from '@/components/xhtml/10_5__A_Bet'
 import XHTML11_6__THING from '@/components/xhtml/11_6__Thing'
 import XHTML12_7__THREE from '@/components/xhtml/12_7__Three'
 import XHTML13_8__NO_LI from '@/components/xhtml/13_8__No_Li'
 import XHTML14_9__CONTR from '@/components/xhtml/14_9__Contr'
 import XHTML15_10__RECL from '@/components/xhtml/15_10__Recl'
 import XHTML16_11__BOOM from '@/components/xhtml/16_11__Boom'
 import XHTML17_ACKNOWLE from '@/components/xhtml/17_Acknowle'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML18_NOTES from '@/components/xhtml/18_Notes'
 import XHTML19_INDEX from '@/components/xhtml/19_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Preface_",
 			"name" : "xhtml/05_Preface_",
 			"component" : XHTML05_PREFACE_
 		},
 		{
 			"path" : "/xhtml/06_1__What",
 			"name" : "xhtml/06_1__What",
 			"component" : XHTML06_1__WHAT
 		},
 		{
 			"path" : "/xhtml/07_2__Fleei",
 			"name" : "xhtml/07_2__Fleei",
 			"component" : XHTML07_2__FLEEI
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js